import React from "react";
import { useTranslation } from 'react-i18next';
import { OFFER_STATUSES } from '../../../../utils/constants'
import { capitalize } from 'lodash-es';
import './InfluencerGuidanceBox.scss'

const InfluencerGuidanceBox = ({userOffer, objectAttributeMetadata, status}) => {
  const { t } = useTranslation();

  const renderInstructions = () => {
    let instructions = [];
    let mediaList = {inst: 'Instagram', tikt: 'TikTok', yout: 'YouTube', othe: 'Other deliverable'}

    if ([
      OFFER_STATUSES.PENDING_POST,
      OFFER_STATUSES.PENDING_COMPLETION,
      OFFER_STATUSES.WORK_NEEDED
    ].includes(status)) {
      Object.keys(userOffer.offer.media_list).forEach((media) => {
        if (media == 'othe') {
          instructions.push(t('influencers.pages.campaign.influencer_guidance_box.upload_other_media_content'))
        } else {
          instructions.push(t('influencers.pages.campaign.influencer_guidance_box.upload_media_content', {media: mediaList[media]}))
        }
      })
    }

    if (objectAttributeMetadata.find((objAttr) => objAttr.influencer_ui_view == 'general' )) {
      instructions.push(t('influencers.pages.campaign.influencer_guidance_box.campaign_participant_question'))
    }

    if ([
      OFFER_STATUSES.PENDING_POST,
      OFFER_STATUSES.PENDING_COMPLETION,
      OFFER_STATUSES.WORK_NEEDED,
      OFFER_STATUSES.PENDING_REVIEW
    ].includes(status) && objectAttributeMetadata.find((objAttr) => objAttr.object_type_form_string == 'user_post' )) {
      Object.keys(userOffer.offer.media_list).forEach((media) => {
        instructions.push(t('influencers.pages.campaign.influencer_guidance_box.user_post_draft_question', {media: mediaList[media]}))
      })
    }

    return instructions;
  }

  return (
    <div className='guidance-box'>
      <div className='content p-4'>
        <p className='mb-0'>{t('influencers.pages.campaign.influencer_guidance_box.current_phase')}</p>
        <h4>{capitalize(status)}</h4>
        <ol className='mb-0'>
          {renderInstructions().map((instruction, idx) => (
            <li key={idx}>{instruction}</li>
          ))}
        </ol>
      </div>
    </div>
  )
}

export default InfluencerGuidanceBox;
